<template>
    <section class="section_3 three-steps" id="section_3">
        <div class="container">
            <h3 class='get-cash'> {{ cmsData.simple_steps_title }} </h3>
            <div class="row">
                <div class="col-12 col-md-4" v-for="data in dataFeature" v-bind:key="data.id">
                    <div class="img">
                        <img v-bind:src="imagePath + data.feature_image" alt="">
                    </div>
                    <h3>{{ data.title }}</h3>
                    <p>{{ data.feature_detail }}</p>
                </div>
            </div>
        </div>
        <div class="section_3_bottom" style="display:inline-block; padding: 10px 22px;
    border-radius: 10px; font-weight: bolder;">
            <router-link :to="{path:cmsData.simple_steps_sub_title_link}"> {{ cmsData.simple_steps_sub_title }} </router-link>
        </div>
    </section>
</template>

<script>
export default {
    name: "CashHome",
    props:['cmsData','dataFeature'],
    data() {
        return {
            imagePath: this.$api + "upload/feature_image/"
        };
    }
}
</script>

<style scoped>
.cls-1 {
    fill: none;
    stroke: #f1852a;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: .71px
}
.cls-1, .cls-2 {
    fill: none;
    stroke: #f1852a;
    stroke-linecap: round
}
.cls-1 {
    stroke-linejoin: round
}
.cls-2 {
    stroke-miterlimit: 10
}
</style>